import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _find from 'lodash/find';

import Query from '../../../../GraphQL/util/QueryComponent';
import {
  queryExamQuestions,
  getMockExamQuestionAssets,
} from '../../../../GraphQL/query/MockExam/MockExamSolutionGroups.query';
import SolutionDetails from './SolutionDetails';
import SolutionLoadingView from './LoadingView';

const getTitle = (title, currentSectionIndex, questionTitle) => {
  const prefix = `Part ${currentSectionIndex}`;

  const formattedTitle = `${prefix} ${title} | ${questionTitle}`;
  return formattedTitle;
};

class SolutionListQuery extends Component {
  static propTypes = {
    examId: PropTypes.string,
    examCardId: PropTypes.string,
  };

  render() {
    const { examId, examCardId } = this.props;

    return (
      <Query query={queryExamQuestions} variables={{ mockExamId: examId, examCardId }}>
        {examQuestionsData => {
          const { mockExamQuestions, myMockExamAnswers } = examQuestionsData;
          return (
            <SolutionDetailsContainer
              {...this.props}
              mockExamQuestions={mockExamQuestions}
              myMockExamAnswers={myMockExamAnswers}
            />
          );
        }}
      </Query>
    );
  }
}

class SolutionDetailsContainer extends Component {
  static propTypes = {
    examId: PropTypes.string,
    examCardId: PropTypes.string,
    sectionIndex: PropTypes.number.isRequired,
    questionIndex: PropTypes.number.isRequired, // for array purpose
    itemNumber: PropTypes.number.isRequired, // for query purpose
    onBackClick: PropTypes.func,
  };

  static defaultProps = {
    onBackClick: PropTypes.func,
  };

  state = {
    sectionIndex: this.props.sectionIndex,
    questionIndex: this.props.questionIndex,
  };

  handleNextClick = () => {
    const { mockExamQuestions } = this.props;
    const { sectionIndex, questionIndex } = this.state;
    const currentSection = mockExamQuestions.sections[sectionIndex];
    if (currentSection.questions.length > questionIndex + 1) {
      this.setState({ questionIndex: questionIndex + 1 });
    } else {
      this.setState({ sectionIndex: sectionIndex + 1, questionIndex: 0 });
    }
  };

  handlePreviousClick = () => {
    const { mockExamQuestions } = this.props;
    const { sectionIndex, questionIndex } = this.state;
    if (questionIndex > 0) {
      this.setState({ questionIndex: questionIndex - 1 });
    } else {
      const prevSection = mockExamQuestions.sections[sectionIndex - 1];

      this.setState({
        sectionIndex: sectionIndex - 1,
        questionIndex: prevSection.questions.length - 1,
      });
    }
  };

  render() {
    const { examId, onBackClick, mockExamQuestions, myMockExamAnswers } = this.props;
    const { sectionIndex, questionIndex } = this.state;

    const currentSection = mockExamQuestions.sections[sectionIndex];
    const currentQuestion = currentSection.questions[questionIndex];

    const isLastQuestion =
      currentSection.questions.length === questionIndex + 1 &&
      mockExamQuestions.sections.length === sectionIndex + 1;
    const isFirstQuestion = sectionIndex === 0 && questionIndex === 0;

    const title = getTitle(currentSection.title, sectionIndex + 1, currentQuestion.title);

    return (
      <Query
        query={getMockExamQuestionAssets}
        variables={{
          mockExamId: examId,
          questionType: currentQuestion.type,
          keyCode: currentQuestion.examKeyCode,
          itemNumber: currentQuestion.itemNumber,
        }}
        renderLoading={() => <SolutionLoadingView title={title} />}
      >
        {({ mockExamQuestionAsset }) => {
          return (
            <SolutionDetails
              title={title}
              currentSection={currentSection}
              currentQuestion={currentQuestion}
              currentAssets={mockExamQuestionAsset}
              allAnswers={myMockExamAnswers.answers}
              navigationValue={{
                sectionIndex,
                itemNumber: currentQuestion.itemNumber,
                totalQuestionsInSection: currentSection.questions.length,
                isFirstQuestion,
                isLastQuestion,
              }}
              onBackClick={onBackClick}
              onPreviousClick={this.handlePreviousClick}
              onNextClick={this.handleNextClick}
            />
          );
        }}
      </Query>
    );
  }
}

export default SolutionListQuery;
